export { default } from './product-discontinued'; 